import type { ReactNode } from 'react';
import { useLocalization } from '@/services/localizationService';

const disclosureLinks = {
  privacy: (text: ReactNode) => (
    <a
      className="underline"
      href="https://www.hcaptcha.com/privacy"
      rel="noreferrer"
      target="_blank"
    >
      {text}
    </a>
  ),
  tos: (text: ReactNode) => (
    <a
      className="underline"
      href="https://www.hcaptcha.com/terms"
      rel="noreferrer"
      target="_blank"
    >
      {text}
    </a>
  ),
};

export function HCaptchaDisclosure({
  className = '',
  textClassName = 'text-center text-[11px] leading-4 text-gray-300',
}: {
  className?: string;
  textClassName?: string;
}) {
  const { t, data } = useLocalization();

  return (
    <p className={`${textClassName} ${className}`}>
      {t(data.common.hcaptcha, disclosureLinks)}
    </p>
  );
}
